module.exports = __webpack_public_path__ + "img/slow_logo.d5b7f6f8.png";